export const washingCount = {
  title: 'Washing Count',
}
